import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyframe, rhombus"><path d="M14.6512 3.09102C13.1867 1.62656 10.8124 1.62656 9.3479 3.09102L3.09054 9.34835C1.62607 10.8128 1.62607 13.1872 3.09053 14.6517L9.34789 20.909C10.8124 22.3735 13.1867 22.3735 14.6512 20.909L20.9086 14.6517C22.373 13.1872 22.373 10.8128 20.9086 9.34835L14.6512 3.09102Z" fill="currentColor"/></CentralIconBase>;
};

export default IconKeyframe;
